import React from 'react';
import { Typography } from '@material-ui/core';

export function Title({ children }) {
  return <Typography variant="h6" align="center">{children}</Typography>
}
